import { render, staticRenderFns } from "./ActionDetailedView.vue?vue&type=template&id=373d2016&"
import script from "./ActionDetailedView.vue?vue&type=script&lang=ts&"
export * from "./ActionDetailedView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports